import { URLSearchParams } from 'url';
import convertItemVariablesAttrs from './vehicle';
import convertAttributes from './attributes';

/* return custom color hex if it exists */
export const convertColorCode = code => {
	if (!code || code.length === 0) {
		return false;
	} else if (/(^[0-9A-F]{6}$)|(^#?[0-9A-F]{3}$)/i.test(code)) {
		return `#${code}`;
	}
	return code;
};

/* return btnTarget if it exists, otherwise default to _self */
export const getButtonTarget = btnTarget => {
	return btnTarget && btnTarget.length > 0 ? btnTarget : '_self';
};

/* adds darker border for buttons with custom backgroundColors that are set to a hex value */
export const getDarkerHex = (hex, lum) => {
	if (/(^#?[0-9A-F]{6}$)|(^#?[0-9A-F]{3}$)/i.test(hex)) {
		let hexConverted = String(hex).replace(/[^0-9a-f]/i, '');
		if (hexConverted.length < 6) {
			hexConverted =
				hexConverted[0] +
				hexConverted[0] +
				hexConverted[1] +
				hexConverted[1] +
				hexConverted[2] +
				hexConverted[2];
		}
		const l = lum || 0;
		// convert to decimal and change luminosity
		let rgb = '#';
		for (let i = 0; i < 3; i++) {
			let c = parseInt(hexConverted.substr(i * 2, 2), 16);
			c = Math.round(Math.min(Math.max(0, c + c * l), 255)).toString(16);
			rgb += `00${c}`.substr(c.length);
		}
		return rgb;
	}
	return 'transparent';
};

export const convertButtonAttributesToObj = (attributes, vehicle, isDialog) => {
	const convertedAtributes = {};
	if (attributes) {
		const btnAttributes = convertAttributes(
			convertItemVariablesAttrs(attributes, vehicle)
		);
		Object.keys(btnAttributes).forEach(key => {
			const newKey =
				key === 'class' || key === 'style' ? `data-${key}` : key;
			convertedAtributes[newKey] = btnAttributes[key];
		});
	}
	if (isDialog && !convertedAtributes['data-width']) {
		convertedAtributes['data-width'] = 375;
	}
	return convertedAtributes;
};

const removeBlankSpaces = orig => {
	return orig.split(' ').filter(val => {
		return val && val.length > 0;
	});
};

export const removeIfStatementsFromBtnClasses = orig => {
	const startIndex = orig.indexOf('#if');
	const endIndex = orig.indexOf('#end');
	let newVal = orig;
	if (startIndex > -1 && endIndex > -1) {
		newVal = orig.slice(startIndex, endIndex + 4);
		newVal = orig.replace(newVal, '');
	}
	return removeBlankSpaces(newVal);
};

export const cleanButtonClasses = (btnClasses, btnStyle, isImage, isDialog) => {
	const newClasses = !isImage
		? [
				'btn',
				'btn-block',
				`btn-${btnStyle && btnStyle !== 'block' ? btnStyle : 'default'}`
		  ]
		: ['cst-image'];
	if (isDialog) newClasses.push('dialog');
	if (btnClasses && btnClasses.length > 0) {
		const customClassesArray = removeIfStatementsFromBtnClasses(btnClasses);
		customClassesArray.forEach(className => {
			const c = className.trim();
			if (c.length > 0 && newClasses.indexOf(c) === -1) {
				newClasses.push(c);
			}
		});
	}
	return newClasses.join(' ');
};

export const setBtnUrlParams = (paramString, vehicle, isInternalLink) => {
	const convertedParams = new URLSearchParams(paramString);
	const { uuid } = vehicle;
	if (isInternalLink) {
		if (!convertedParams.get('itemId')) {
			convertedParams.set('itemId', uuid);
		}
		if (!convertedParams.get('vehicleId')) {
			convertedParams.set('vehicleId', uuid);
		}
	}
	convertedParams.forEach((value, key) => {
		if (value && value.indexOf('item') > -1) {
			const field = value.split('.')[1] || false;
			if (field && vehicle[field]) {
				convertedParams.set(key, vehicle[field]);
			}
		}
	});
	return convertedParams.toString();
};

export const createDefaultButton = () => {
	return {
		entityComponentClassName:
			'com.dealer.cms.model.widgets.InventoryButtons',
		btnDisabled: false,
		btnHref: '',
		btnIconAfter: false,
		btnLabel: '',
		btnSize: 'default',
		btnStyle: 'default',
		btnTagName: 'a',
		btnTarget: '_blank',
		device: 'both',
		deviceOverrides: {},
		inventoryClassification: 'all',
		inventoryStatus: 'ALL',
		inventoryType: 'both',
		position: 'pricing',
		showOnDetails: true,
		showOnListings: true,
		type: 'button'
	};
};



// WEBPACK FOOTER //
// ./src/utils/buttons.js